module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cmsdetail"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_vm._l((_vm.breadData), function(item, index) {
    return [(item.name != '首页内容') ? _c('el-breadcrumb-item', {
      key: index,
      attrs: {
        "to": item.url ? item.url : ''
      }
    }, [_c('a', [_vm._v(_vm._s(item.name))])]) : _vm._e()]
  }), _vm._v(" "), (_vm.$route.query.cmspositionId) ? [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/cmsposition',
        query: {
          cmspositionId: _vm.$route.query.cmspositionId,
          isfromdetail: 1
        }
      }
    }
  }, [_c('a', [_vm._v("院校动态")])])] : _vm._e(), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("内容详情")])], 2), _vm._v(" "), _c('div', {
    staticClass: "left_and_right_container"
  }, [_c('div', {
    staticClass: "container_left"
  }, [_c('div', {
    staticClass: "container_left_title"
  }, [_vm._v("\n          " + _vm._s(_vm.itemData.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "container_left_tips"
  }, [_c('div', {
    staticClass: "tips_left"
  }, [_c('div', {
    staticClass: "tips_left_tag"
  }, [_vm._v("\n              " + _vm._s(_vm.breadData[_vm.breadData.length - 1].name) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "operations_common operations_date"
  }, [_c('div', {
    staticClass: "operations_common_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "operations_common_num"
  }, [_vm._v("\n                " + _vm._s(_vm._f("yearForm")(_vm.itemData.create_time)) + "年" + _vm._s(_vm._f("monthForm")(_vm.itemData.create_time)) + "月" + _vm._s(_vm._f("dayForm")(_vm.itemData.create_time)) + "日\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "operations_common operations_hotnum"
  }, [_c('div', {
    staticClass: "operations_common_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "operations_common_num"
  }, [_vm._v("\n                " + _vm._s(_vm.itemData.views_count) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tips_right"
  }, [_c('vshare', {
    attrs: {
      "vshareConfig": _vm.vshareConfig
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container_left_content"
  }, [_c('div', {
    staticClass: "container_left_text html-data ",
    domProps: {
      "innerHTML": _vm._s(_vm.itemData.content)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container_right"
  }, [_c('CmsRecommend')], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5688dd28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/cms/CmsDetail.vue
// module id = 1243
// module chunks = 0